webpackJsonp([195451945045015],{

/***/ 301:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-components-Content----content-module---content---3UcB2","showContent":"src-components-Content----content-module---showContent---zpiDA","download":"src-components-Content----content-module---download---17sfu","inner":"src-components-Content----content-module---inner---35K8z","factbox":"src-components-Content----content-module---factbox---3ASnT","red":"src-components-Content----content-module---red---2rBqY","blue":"src-components-Content----content-module---blue---2rdNs","left":"src-components-Content----content-module---left---37ANH","right":"src-components-Content----content-module---right---ztvM0"};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.contentFragment = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _prismicReactjs = __webpack_require__(114);
	
	var _helper = __webpack_require__(11);
	
	var _contentModule = __webpack_require__(301);
	
	var _contentModule2 = _interopRequireDefault(_contentModule);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(46);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _loader = __webpack_require__(10);
	
	var loaderActions = _interopRequireWildcard(_loader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentContainer = function (_React$Component) {
	  _inherits(ContentContainer, _React$Component);
	
	  function ContentContainer(props) {
	    _classCallCheck(this, ContentContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      contentToggled: false
	    };
	    _this.toggleContent = _this.toggleContent.bind(_this);
	    return _this;
	  }
	
	  ContentContainer.prototype.toggleContent = function toggleContent() {
	    this.setState(function (prevState) {
	      return {
	        contentToggled: !prevState.contentToggled
	      };
	    });
	  };
	
	  ContentContainer.prototype.render = function render() {
	    var renderableContent = (0, _helper.makeContentRenderable)(this.props.content);
	    var contentCssClass = [_contentModule2.default.content];
	    if (this.state.contentToggled) {
	      contentCssClass.push(_contentModule2.default.showContent);
	    }
	    return _react2.default.createElement(
	      'section',
	      { key: 'content', className: contentCssClass.join(' ') },
	      this.props.children,
	      _react2.default.createElement(
	        'article',
	        { className: _contentModule2.default.inner },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.title && _react2.default.createElement(
	            'h1',
	            null,
	            this.props.title[0].text
	          ),
	          _prismicReactjs.RichText.render(renderableContent).props.children
	        )
	      ),
	      this.props.pdf && this.props.pdf.url !== null && _react2.default.createElement(
	        'a',
	        {
	          className: _contentModule2.default.download,
	          href: this.props.pdf.url,
	          target: '_blank',
	          title: 'Download tema som PDF'
	        },
	        _react2.default.createElement(_Icon2.default, { icon: 'print' })
	      )
	    );
	  };
	
	  ContentContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    var _this2 = this;
	
	    if (prevProps.loading && prevProps.loading !== this.props.loading) {
	      setTimeout(function () {
	        return _this2.toggleContent();
	      }, 1000);
	    }
	  };
	
	  return ContentContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loading: state.loader.loading
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var Content = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContentContainer);
	
	Content.defaultProps = {};
	
	Content.propTypes = {};
	
	exports.default = Content;
	var contentFragment = exports.contentFragment = '** extracted graphql fragment **';
	
	/*
	data {
	  content {
	    type
	    text
	    url
	    spans {
	      start
	      end
	      type
	      data {
	        link_type
	        url
	        target
	      }
	    }
	    oembed {
	      type
	      embed_url
	      title
	      provider_name
	      thumbnail_url
	      height
	      width
	      version
	      author_name
	      author_url
	      provider_url
	      thumbnail_width
	      thumbnail_height
	      html
	    }
	  }
	}
	*/

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.imageFragment = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _loader = __webpack_require__(10);
	
	var loaderActions = _interopRequireWildcard(_loader);
	
	var _imageModule = __webpack_require__(41);
	
	var _imageModule2 = _interopRequireDefault(_imageModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageContainer = function (_React$Component) {
	  _inherits(ImageContainer, _React$Component);
	
	  function ImageContainer(props) {
	    _classCallCheck(this, ImageContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      loaded: false
	    };
	    _this.onLoadHandler = _this.onLoadHandler.bind(_this);
	    return _this;
	  }
	
	  ImageContainer.prototype.onLoadHandler = function onLoadHandler() {
	    this.setState({ loaded: true });
	  };
	
	  ImageContainer.prototype.render = function render() {
	    var url = this.props.img.url;
	    var alt = this.props.alt;
	
	    var cssClass = [_imageModule2.default.bgimage].concat(this.props.className);
	    if (this.state.loaded) {
	      cssClass.push(_imageModule2.default.in);
	    }
	    return _react2.default.createElement('img', {
	      className: cssClass.join(' '),
	      src: '' + url,
	      onLoad: this.onLoadHandler,
	      alt: alt
	    });
	  };
	
	  return ImageContainer;
	}(_react2.default.Component);
	
	ImageContainer.defaultProps = {};
	
	ImageContainer.propTypes = {};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var Image = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ImageContainer);
	
	exports.default = Image;
	var imageFragment = exports.imageFragment = '** extracted graphql fragment **';

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navigationitemModule = __webpack_require__(42);
	
	var _navigationitemModule2 = _interopRequireDefault(_navigationitemModule);
	
	var _Image = __webpack_require__(20);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function NavigationItem(_ref) {
	  var large = _ref.large,
	      className = _ref.className,
	      props = _objectWithoutProperties(_ref, ['large', 'className']);
	
	  var cssClass = large ? [_navigationitemModule2.default.item_lg] : [_navigationitemModule2.default.item];
	  var url = props.url,
	      navigation_image = props.navigation_image,
	      navigation_title = props.navigation_title,
	      style = props.style;
	
	  if (className) {
	    cssClass.push(className);
	  }
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    {
	      to: url,
	      title: navigation_title,
	      className: cssClass.join(' '),
	      style: style
	    },
	    _react2.default.createElement(
	      'span',
	      { className: _navigationitemModule2.default.overlay },
	      _react2.default.createElement(
	        'span',
	        { className: _navigationitemModule2.default.title },
	        navigation_title
	      )
	    ),
	    _react2.default.createElement('img', {
	      className: _navigationitemModule2.default.img,
	      src: navigation_image.url,
	      alt: navigation_title
	    })
	  );
	}
	
	NavigationItem.defaultProps = {};
	
	NavigationItem.propTypes = {};
	
	exports.default = NavigationItem;
	module.exports = exports['default'];

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item_lg":"src-components-NavigationItem----navigationitem-module---item_lg---34Qfg","item":"src-components-NavigationItem----navigationitem-module---item---1158x","overlay":"src-components-NavigationItem----navigationitem-module---overlay---19zyz","img":"src-components-NavigationItem----navigationitem-module---img---2geeR","title":"src-components-NavigationItem----navigationitem-module---title---2HQs1"};

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _navigationlistModule = __webpack_require__(97);
	
	var _navigationlistModule2 = _interopRequireDefault(_navigationlistModule);
	
	var _helper = __webpack_require__(11);
	
	var _NavigationItem = __webpack_require__(34);
	
	var _NavigationItem2 = _interopRequireDefault(_NavigationItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationListContainer = function (_React$Component) {
	  _inherits(NavigationListContainer, _React$Component);
	
	  function NavigationListContainer(props) {
	    _classCallCheck(this, NavigationListContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      toggled: props.toggled
	    };
	    _this.items = [];
	    return _this;
	  }
	
	  NavigationListContainer.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.items) {
	      this.items = this.props.items.map(function (x) {
	        return _extends({}, x, { url: (0, _helper.linkResolver)(x.page.type, x.page.uid) });
	      });
	    }
	  };
	
	  NavigationListContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setState({
	      toggled: nextProps.toggled
	    });
	  };
	
	  NavigationListContainer.prototype.render = function render() {
	    if (!this.props.items) return null;
	    var cssClass = [_navigationlistModule2.default.list];
	    var itemCssClass = [_navigationlistModule2.default.item];
	    if (this.state.toggled) {
	      itemCssClass.push(_navigationlistModule2.default.in);
	      cssClass.push(_navigationlistModule2.default.show);
	    }
	    return _react2.default.createElement(
	      'nav',
	      { className: cssClass.join(' ') },
	      this.items.map(function (x, i) {
	        return _react2.default.createElement(_NavigationItem2.default, _extends({ key: 'item_' + i, className: itemCssClass.join(' '), style: { 'transitionDelay': i * 50 + 'ms' } }, x));
	      })
	    );
	  };
	
	  return NavigationListContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    toggled: state.navigation.navToggled
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var NavigationList = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NavigationListContainer);
	
	NavigationList.defaultProps = {};
	
	NavigationList.propTypes = {};
	
	exports.default = NavigationList;
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"src-components-NavigationList----navigationlist-module---list---3Nmqs","show":"src-components-NavigationList----navigationlist-module---show---1tHfQ","item":"src-components-NavigationList----navigationlist-module---item---167QW","in":"src-components-NavigationList----navigationlist-module---in---1S02a"};

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block-img":"src-templates-article----article-module---block-img---m5Pij","content":"src-templates-article----article-module---content---Vwp2b","showContent":"src-templates-article----article-module---showContent---1MW7c"};

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _articleModule = __webpack_require__(312);
	
	var _articleModule2 = _interopRequireDefault(_articleModule);
	
	__webpack_require__(112);
	
	var _BackgroundImage = __webpack_require__(45);
	
	var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);
	
	var _Content = __webpack_require__(190);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Image = __webpack_require__(20);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Main = __webpack_require__(47);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Meta = __webpack_require__(48);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _Navigation = __webpack_require__(49);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _NavigationList = __webpack_require__(70);
	
	var _NavigationList2 = _interopRequireDefault(_NavigationList);
	
	var _helper = __webpack_require__(11);
	
	var _loader = __webpack_require__(10);
	
	var loaderActions = _interopRequireWildcard(_loader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleContainer = function (_React$Component) {
	  _inherits(ArticleContainer, _React$Component);
	
	  function ArticleContainer(props) {
	    _classCallCheck(this, ArticleContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  ArticleContainer.prototype.componentWillMount = function componentWillMount() {
	    this.props.toggleLoader(true);
	  };
	
	  ArticleContainer.prototype.render = function render() {
	    var _props$data$articleJs = this.props.data.articleJson,
	        url = _props$data$articleJs.url,
	        meta_image = _props$data$articleJs.meta_image,
	        meta_title = _props$data$articleJs.meta_title,
	        data = _props$data$articleJs.data;
	    var content = data.content,
	        background_image = data.background_image,
	        image = data.image,
	        title = data.title,
	        home_link = data.home_link,
	        navigation = data.navigation,
	        pdf = data.pdf;
	
	    var homelink = (0, _helper.linkResolver)(home_link.type, home_link.uid);
	    var navitems = (0, _helper.navResolver)(navigation.type, navigation.uid);
	    return [_react2.default.createElement(_Meta2.default, _extends({
	      key: 'meta',
	      url: url,
	      metaTitle: meta_title,
	      metaImage: meta_image
	    }, this.props.data.site.siteMetadata)), homelink && homelink === '/' && _react2.default.createElement(_Navigation2.default, { key: 'nav_home', x: 'left', home: homelink }), homelink && homelink !== '/' && _react2.default.createElement(_Navigation2.default, { key: 'nav', nav: true, back: homelink }), _react2.default.createElement(_NavigationList2.default, { key: 'navitems', items: navitems }), _react2.default.createElement(
	      _Main2.default,
	      { key: 'main' },
	      _react2.default.createElement(_BackgroundImage2.default, { img: background_image }),
	      _react2.default.createElement(
	        _Content2.default,
	        { content: content, title: title, pdf: pdf },
	        _react2.default.createElement(_Image2.default, { img: image })
	      )
	    )];
	  };
	
	  return ArticleContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    toggleLoader: function toggleLoader(loading) {
	      dispatch(loaderActions.toggleLoader(loading));
	    }
	  };
	};
	
	var Article = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ArticleContainer);
	
	exports.default = Article;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-article-index-jsx-347b6a1d884d1bb8ab74.js